// Drag-and-drop de ficheros para modales de upload. El componente debe tener
// `this.files` como array y enganchar los handlers al root del template.
export default {
  data() {
    return {
      isDragging: false,
      // Contador para evitar flicker al entrar en elementos hijos.
      dragCounter: 0,
    };
  },

  methods: {
    onDragEnter() {
      this.dragCounter++;
      this.isDragging = true;
    },
    onDragLeave() {
      this.dragCounter--;
      if (this.dragCounter <= 0) {
        this.dragCounter = 0;
        this.isDragging = false;
      }
    },
    onDrop(event) {
      this.dragCounter = 0;
      this.isDragging = false;
      const dropped = Array.from(event.dataTransfer?.files || []);
      if (dropped.length > 0) {
        this.files = [...(this.files || []), ...dropped];
      }
    },

    fileIcon(file) {
      const ext = (file.name.split('.').pop() || '').toLowerCase();
      if (ext === 'pdf') return 'file-pdf';
      if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) return 'file-image';
      if (['doc', 'docx'].includes(ext)) return 'file-word';
      if (['xls', 'xlsx', 'csv'].includes(ext)) return 'file-excel';
      if (['ppt', 'pptx'].includes(ext)) return 'file-powerpoint';
      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return 'file-archive';
      if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(ext)) return 'file-video';
      if (['mp3', 'wav', 'ogg', 'm4a'].includes(ext)) return 'file-audio';
      if (['dwg', 'dxf', 'ifc', 'rvt'].includes(ext)) return 'drafting-compass';
      return 'file';
    },
    formatFileSize(bytes) {
      if (!bytes && bytes !== 0) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / 1024 / 1024).toFixed(1) + ' MB';
    },
  },
};
